import React from 'react';
import Link from 'next/link';

import { ConditionalWrapper } from 'shared/components/conditional-wrapper';

type ConditionalLinkProps = {
  url: string | null;
  children: React.ReactNode;
};

export const ConditionalLink = ({ url, children }: ConditionalLinkProps): JSX.Element => (
  <ConditionalWrapper condition={!!url} wrapper={(wrapperChildren) => <Link href={url ?? ''}>{wrapperChildren}</Link>}>
    {children}
  </ConditionalWrapper>
);
